import React, { useState } from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import UserSettingsProfileModal from './UserSettingsProfileModal';
import { useAppContext } from '../../../../Services/AppContext';

const UserSettingsProfileButton: React.FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { userData } = useAppContext();

	return (
		<>
			<Button
				title='base.shared.myProfile'
				theme={Theme.BLUE}
				onClick={() => setIsOpen(true)}
			/>
			{isOpen && (
				<UserSettingsProfileModal
					userId={userData.id}
					isOpen
					onClose={() => setIsOpen(false)}
				/>
			)}
		</>
	);
};

export default UserSettingsProfileButton;
